<script setup lang="ts">

import NamaIcon from "@/components/icons/NamaIcon.vue";
import Translator from "@/utils/common/Translator.ts";
import type {GetMainMenuItemsParams, MenuItemDef} from "ag-grid-enterprise";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import {copyToClipboard} from "quasar";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import {useMessagesStore} from "@/stores/ToastDataStore.ts";

const props = defineProps<{ params: MenuItemDef & GetMainMenuItemsParams }>()

async function onClick(e: MouseEvent) {
  if (!e)
    return;
  let colDef = props.params.column?.getColDef();
  if (ObjectChecker.isEmptyOrNull(colDef))
    return;
  let headerName = colDef.headerName;
  const colId = ObjectChecker.getFirstNotEmptyObj(colDef.headerComponentParams?.colId, AGGridUtils.decodeColId(colDef.colId));
  if (ObjectChecker.isEmptyOrNull(headerName))
    headerName = Translator.translateTitledId(colDef.headerComponentParams?.entityType, colId)
  if (ObjectChecker.isEmptyOrNull(headerName))
    return;
  await copyToClipboard(headerName).then(() => {
    useMessagesStore().pushMessageStr(Translator.translateId("copied"))
  }).finally(()=>{
    props.params.api.hidePopupMenu?.();
  })
}
</script>
<template>
  <div class="ag-menu-option  hover:[background:--ag-row-hover-color]" role="menuitem" tabindex="-1" @click="onClick">
    <span class="ag-menu-option-part ag-menu-option-icon" role="presentation">
      <NamaIcon default-icon="nm-copy" class="tw-size-4"/>
    </span>
    <span class="ag-menu-option-part ag-menu-option-text">
      <span v-text="Translator.translateId(props.params.name)"/>
    </span>
    <span class="ag-menu-option-part ag-menu-option-popup-pointer"/>
    <span data-ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"/>
  </div>
</template>
